export default "__VITE_ASSET__f4a76d0a__"